import Parallax from 'parallax-js';

export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    return {
      provide: {
        Parallax,
      },
    };
  }
})